
import { Indicator, Approach } from './types';

export const INDICATORS: Indicator[] = [
  // 1. REGULAÇÃO EMOCIONAL
  {
    id: 'reg_pos_1',
    nome: 'Consciência emocional',
    dominio: 'Regulação Emocional',
    eixo: 'positive',
    descricao_clinica: 'Capacidade de identificar e nomear emoções.',
    interpretacao: 'Aumento indica maior clareza afetiva e alfabetização emocional.',
    tags_teoricas: ['emocao', 'consciencia']
  },
  {
    id: 'reg_pos_2',
    nome: 'Tolerância ao desconforto emocional',
    dominio: 'Regulação Emocional',
    eixo: 'positive',
    descricao_clinica: 'Capacidade de permanecer em contato com emoções difíceis sem agir impulsivamente.',
    interpretacao: 'Melhora na resiliência e redução de impulsividade.',
    tags_teoricas: ['resiliencia', 'tolerancia']
  },
  {
    id: 'reg_pos_3',
    nome: 'Capacidade de autorregulação',
    dominio: 'Regulação Emocional',
    eixo: 'positive',
    descricao_clinica: 'Habilidade de recuperar equilíbrio emocional após ativação.',
    interpretacao: 'Crescimento na autonomia regulatória.',
    tags_teoricas: ['autorregulacao', 'homeostase']
  },
  {
    id: 'reg_neg_1',
    nome: 'Reatividade emocional',
    dominio: 'Regulação Emocional',
    eixo: 'negative',
    descricao_clinica: 'Intensidade e rapidez das respostas emocionais.',
    interpretacao: 'Redução indica maior estabilidade e controle inibitório.',
    tags_teoricas: ['reatividade', 'intensidade']
  },
  {
    id: 'reg_neg_2',
    nome: 'Oscilação emocional',
    dominio: 'Regulação Emocional',
    eixo: 'negative',
    descricao_clinica: 'Instabilidade frequente do humor.',
    interpretacao: 'Queda reflete maior constância afetiva.',
    tags_teoricas: ['humor', 'oscilacao']
  },
  {
    id: 'reg_neg_3',
    nome: 'Evitação emocional',
    dominio: 'Regulação Emocional',
    eixo: 'negative',
    descricao_clinica: 'Tentativa persistente de evitar sentir emoções desagradáveis.',
    interpretacao: 'Redução indica maior abertura à experiência (ACT).',
    tags_teoricas: ['esquiva', 'evitacao']
  },

  // 2. COGNIÇÃO
  {
    id: 'cog_pos_1',
    nome: 'Flexibilidade cognitiva',
    dominio: 'Cognição',
    eixo: 'positive',
    descricao_clinica: 'Capacidade de considerar múltiplas perspectivas.',
    interpretacao: 'Melhora na adaptação mental e redução de rigidez.',
    tags_teoricas: ['flexibilidade', 'tcc']
  },
  {
    id: 'cog_pos_2',
    nome: 'Clareza de pensamento',
    dominio: 'Cognição',
    eixo: 'positive',
    descricao_clinica: 'Organização mental e coerência narrativa.',
    interpretacao: 'Aumento na organização do self e comunicação.',
    tags_teoricas: ['organizacao', 'narrativa']
  },
  {
    id: 'cog_pos_3',
    nome: 'Insight psicológico',
    dominio: 'Cognição',
    eixo: 'positive',
    descricao_clinica: 'Compreensão dos próprios padrões internos.',
    interpretacao: 'Crescimento na consciência de si e elaboração.',
    tags_teoricas: ['insight', 'elaboracao']
  },
  {
    id: 'cog_neg_1',
    nome: 'Ruminação',
    dominio: 'Cognição',
    eixo: 'negative',
    descricao_clinica: 'Pensamentos repetitivos e circulares.',
    interpretacao: 'Redução indica maior presença no agora e foco.',
    tags_teoricas: ['ruminacao', 'foco']
  },
  {
    id: 'cog_neg_2',
    nome: 'Catastrofização',
    dominio: 'Cognição',
    eixo: 'negative',
    descricao_clinica: 'Tendência a antecipar desfechos negativos extremos.',
    interpretacao: 'Queda indica pensamento mais realista e funcional.',
    tags_teoricas: ['distorcao', 'ansiedade']
  },
  {
    id: 'cog_neg_3',
    nome: 'Rigidez cognitiva',
    dominio: 'Cognição',
    eixo: 'negative',
    descricao_clinica: 'Dificuldade em rever crenças ou interpretações.',
    interpretacao: 'Redução permite novas aprendizagens e mudanças.',
    tags_teoricas: ['rigidez', 'crencas']
  },

  // 3. COMPORTAMENTO
  {
    id: 'comp_pos_1',
    nome: 'Proatividade no enfrentamento',
    dominio: 'Comportamento',
    eixo: 'positive',
    descricao_clinica: 'Ações dirigidas à resolução de dificuldades.',
    interpretacao: 'Aumento na agência e eficácia pessoal.',
    tags_teoricas: ['agencia', 'enfrentamento']
  },
  {
    id: 'comp_pos_2',
    nome: 'Autocuidado comportamental',
    dominio: 'Comportamento',
    eixo: 'positive',
    descricao_clinica: 'Engajamento em práticas saudáveis.',
    interpretacao: 'Melhora na preservação da saúde e rotina.',
    tags_teoricas: ['autocuidado', 'saude']
  },
  {
    id: 'comp_pos_3',
    nome: 'Assertividade comportamental',
    dominio: 'Comportamento',
    eixo: 'positive',
    descricao_clinica: 'Expressão clara de necessidades e limites.',
    interpretacao: 'Crescimento na imposição de limites saudáveis.',
    tags_teoricas: ['assertividade', 'limites']
  },
  {
    id: 'comp_neg_1',
    nome: 'Procrastinação',
    dominio: 'Comportamento',
    eixo: 'negative',
    descricao_clinica: 'Adiamento recorrente de tarefas relevantes.',
    interpretacao: 'Redução indica melhor ativação comportamental.',
    tags_teoricas: ['procrastinacao', 'ativacao']
  },
  {
    id: 'comp_neg_2',
    nome: 'Evitação experiencial',
    dominio: 'Comportamento',
    eixo: 'negative',
    descricao_clinica: 'Fuga de situações internas ou externas desconfortáveis.',
    interpretacao: 'Redução reflete maior engajamento com a vida.',
    tags_teoricas: ['esquiva', 'experiencial']
  },
  {
    id: 'comp_neg_3',
    nome: 'Compulsividade',
    dominio: 'Comportamento',
    eixo: 'negative',
    descricao_clinica: 'Comportamentos repetitivos difíceis de controlar.',
    interpretacao: 'Queda indica maior regulação do impulso.',
    tags_teoricas: ['impulso', 'compulsao']
  },

  // 4. VÍNCULO / RELACIONAL
  {
    id: 'rel_pos_1',
    nome: 'Capacidade de vinculação',
    dominio: 'Vínculo / Relacional',
    eixo: 'positive',
    descricao_clinica: 'Facilidade em estabelecer relações de confiança.',
    interpretacao: 'Melhora na segurança do apego e aliança.',
    tags_teoricas: ['vinculo', 'apego']
  },
  {
    id: 'rel_pos_2',
    nome: 'Comunicação emocional',
    dominio: 'Vínculo / Relacional',
    eixo: 'positive',
    descricao_clinica: 'Expressão adequada de sentimentos nas relações.',
    interpretacao: 'Crescimento na conexão interpessoal.',
    tags_teoricas: ['comunicacao', 'afeto']
  },
  {
    id: 'rel_pos_3',
    nome: 'Autonomia relacional',
    dominio: 'Vínculo / Relacional',
    eixo: 'positive',
    descricao_clinica: 'Equilíbrio entre proximidade e independência.',
    interpretacao: 'Individuação saudável e interdependência.',
    tags_teoricas: ['autonomia', 'individuacao']
  },
  {
    id: 'rel_neg_1',
    nome: 'Dependência emocional',
    dominio: 'Vínculo / Relacional',
    eixo: 'negative',
    descricao_clinica: 'Necessidade excessiva de validação externa.',
    interpretacao: 'Redução indica fortalecimento do self.',
    tags_teoricas: ['dependencia', 'validacao']
  },
  {
    id: 'rel_neg_2',
    nome: 'Evitação social',
    dominio: 'Vínculo / Relacional',
    eixo: 'negative',
    descricao_clinica: 'Retraimento persistente de interações sociais.',
    interpretacao: 'Aumento na participação social.',
    tags_teoricas: ['isolamento', 'social']
  },
  {
    id: 'rel_neg_3',
    nome: 'Reatividade interpessoal',
    dominio: 'Vínculo / Relacional',
    eixo: 'negative',
    descricao_clinica: 'Respostas intensas a frustrações relacionais.',
    interpretacao: 'Melhora na regulação dentro do vínculo.',
    tags_teoricas: ['conflito', 'interpessoal']
  },

  // 5. FUNCIONALIDADE / VIDA DIÁRIA
  {
    id: 'func_pos_1',
    nome: 'Autonomia funcional',
    dominio: 'Funcionalidade / Vida Diária',
    eixo: 'positive',
    descricao_clinica: 'Capacidade de gerir rotinas e responsabilidades.',
    interpretacao: 'Aumento na competência diária.',
    tags_teoricas: ['autonomia', 'cotidiano']
  },
  {
    id: 'func_pos_2',
    nome: 'Engajamento ocupacional',
    dominio: 'Funcionalidade / Vida Diária',
    eixo: 'positive',
    descricao_clinica: 'Participação em trabalho, estudo ou atividades significativas.',
    interpretacao: 'Valorização da ocupação e produtividade subjetiva.',
    tags_teoricas: ['trabalho', 'estudo']
  },
  {
    id: 'func_pos_3',
    nome: 'Organização da vida diária',
    dominio: 'Funcionalidade / Vida Diária',
    eixo: 'positive',
    descricao_clinica: 'Estruturação prática do cotidiano.',
    interpretacao: 'Melhora na previsibilidade e estabilidade prática.',
    tags_teoricas: ['organizacao', 'rotina']
  },
  {
    id: 'func_neg_1',
    nome: 'Prejuízo funcional percebido',
    dominio: 'Funcionalidade / Vida Diária',
    eixo: 'negative',
    descricao_clinica: 'Impacto subjetivo do sofrimento na vida prática.',
    interpretacao: 'Redução indica melhora na qualidade de vida.',
    tags_teoricas: ['prejuizo', 'sofrimento']
  },
  {
    id: 'func_neg_2',
    nome: 'Desorganização cotidiana',
    dominio: 'Funcionalidade / Vida Diária',
    eixo: 'negative',
    descricao_clinica: 'Dificuldade em manter rotinas básicas.',
    interpretacao: 'Melhora na estruturação funcional.',
    tags_teoricas: ['caos', 'executiva']
  },
  {
    id: 'func_neg_3',
    nome: 'Sensibilidade sensorial excessiva',
    dominio: 'Funcionalidade / Vida Diária',
    eixo: 'negative',
    descricao_clinica: 'Hiper-reatividade a estímulos ambientais.',
    interpretacao: 'Redução de sobrecarga sensorial.',
    tags_teoricas: ['sensorial', 'ambiente']
  }
];

export const APPROACH_LIST = Object.values(Approach);
